import React from 'react';

const TestimonialCard = ({item}) => {
    return (
        <div className='col-md-4'>
            <div className=' shadow border rounded'>
                <p className='p-4 fs-5 text-secondary'>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptatibus nesciunt dolorum quo veritatis sint odit.</p>
                <div className='d-flex p-4 align-items-center'>
                    <img src={item.img} alt="" />
                    <div className='ms-2'>
                        <h5>{item.name}</h5>
                        <p>California</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestimonialCard;